import React from 'react';

import WebAddress from './WebAddress';

function webAddress(path) {
  return (item, handleWebAddressClick) => {
    const address = item.getIn(path);

    if (!address) {
      return null;
    }
    return <WebAddress text={address} handleClick={handleWebAddressClick} />;
  };
}

function transformArray(path) {
  return (item) => {
    const result = item.getIn(path);

    if (!result) {
      return null;
    }

    return result.join(', ');
  };
}

const TimelinesOfDeliveries = transformArray(['supplierDetailsEntity', 'timelines']);
const AlternativeCompanyNames = transformArray(['supplierData', 'supplierNameSynonyms']);
const PossibleDeliveryDestinations = transformArray(['supplierDetailsEntity', 'destinationsServed']);
const RestrictedDeliveryDestinations = transformArray(['supplierDetailsEntity', 'destinationsNonServed']);

const rcsSupplierInfoTableMapping = [
  ['Company name (Main)', (item) => item.getIn(['supplierData', 'supplierName'])],
  ['Company name (Synonyms)', AlternativeCompanyNames],

  ['Web address', webAddress(['supplierDetailsEntity', 'supplierUrl'])],

  ['Contact email', (item) => item.getIn(['supplierDetailsEntity', 'supplierEmail'])],
  ['Contact phone', (item) => item.getIn(['supplierDetailsEntity', 'supplierPhone'])],

  ['Address', (item) => item.getIn(['supplierDetailsEntity', 'supplierAddress'])],

  ['Geographical location', (item) => item.getIn(['supplierDetailsEntity', 'supplierGeoLocation'])],
  ['Business Model', (item) => item.getIn(['supplierDetailsEntity', 'supplierBusinessModel'])],
  ['Chemistry Expertise / Segregation', (item) => item.getIn(['supplierDetailsEntity', 'supplierExpertise'])],
  ['Preferred Carrier', (item) => item.getIn(['supplierDetailsEntity', 'preferredCarrier'])],
  ['Controlled Substance License', (item) => item.getIn(['supplierDetailsEntity', 'controlledSubstanceLicense'])],

  ['Timelines of deliveries', TimelinesOfDeliveries],

  ['Data update frequency', (item) => item.getIn(['supplierDetailsEntity', 'updatesFrequency'])],
  ['Supplier quality', (item) => item.getIn(['supplierDetailsEntity', 'supplierQuality'])],
  ['Countries to which delivery is possible', PossibleDeliveryDestinations],
  ['Countries to which delivery is not possible', RestrictedDeliveryDestinations],
];

export default rcsSupplierInfoTableMapping;
